import { useCallback } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { useFinancialDocumentBulkSelection } from "./FinancialDocumentBulkSelection/useFinancialDocumentBulkSelection";
import { useOpenFinancialDocumentsTask } from "./useOpenFinancialDocumentsTask";

const getEntityIds = (documents: FinancialDocumentListItem[]): number[] => [
    ...new Set(
        documents
            .map((document) => document.entity?.id)
            .filter((id): id is number => id != null),
    ),
];

export function useFinancialDocumentsBulkCreateTask() {
    const { filtersSelection, selected } = useFinancialDocumentBulkSelection();
    const openFinancialDocumentsTask = useOpenFinancialDocumentsTask();

    return useCallback(() => {
        if (filtersSelection) {
            openFinancialDocumentsTask({
                filters: filtersSelection,
                entityIds: filtersSelection.entityIds,
            });
            return;
        }
        openFinancialDocumentsTask({
            financialDocumentIds: selected.map(({ id }) => id),
            entityIds: getEntityIds(selected),
        });
    }, [filtersSelection, selected, openFinancialDocumentsTask]);
}
